import sessionReader from '../../../../../../store/readHelpers/SessionReader';
import i18nService from '../../../../../../services/i18nService';
import sessionCache from '../../../../../../services/SessionCache';

/**
 * Some config constants for SpellChecker
 * http://spellchecker-1894003643.eu-west-1.elb.amazonaws.com' redirects to 'https://spellcheck.inspera.no/',
 */
const SPELLCHECKER_HOST = window.spellCheckerHost || 'https://spellcheckv2.inspera.com';


const getWProofReaderLanguage = () => {
    const sessionLanguage = sessionReader.getLanguage();
    const lang = window.marketplaceProperties.SPELLCHECKER_DEFAULT_LANGUAGE || 'auto';
    const localization = i18nService.languageMapIetfToCKEditor[sessionLanguage] || 'en';

    return {
        lang,
        localization,
    };
};

const saveQuestionConfig = (changedOptions, questionId) => {
    const sessionStorageKey = `spell_${questionId}`;
    const questionConfig = getQuestionConfig(questionId);
    const config = { ...questionConfig, ...changedOptions };
    sessionCache.setItem(sessionStorageKey, JSON.stringify(config));
};

const getQuestionConfig = (questionId) => {
    try {
        return JSON.parse(sessionCache.getItem(`spell_${questionId}`));
    } catch (error) {
        return {};
    }
};

const spellcheckerConfig = {
    configureWProofReaderGeneralConfig() {
        window.WEBSPELLCHECKER_CONFIG = {
            autoSearch: false,
            autoDestroy: true,
            serviceProtocol: 'https',
            serviceHost: SPELLCHECKER_HOST.substr(SPELLCHECKER_HOST.indexOf('://') + 3),
            servicePath: '/',
            enableGrammar: false,
            enableLanguagesInBadgeButton: false,
            disableDictionariesPreferences: true,
            settingsSections: ['options', 'languages'],
            removeBranding: true,
        };
    },

    configureWProofReaderOnInstanceReady(editor, questionId) {
        if (window.WEBSPELLCHECKER) {
            try {
                const config = {
                    container: editor.container.$.getElementsByClassName('cke_wysiwyg_div')[0],
                    disableOptionsStorage: ['all'],
                    onCommitOptions: (changedOptions) => {
                        saveQuestionConfig(changedOptions, questionId);
                    },
                    onToggle: (instance) => {
                        saveQuestionConfig({ autoStartup: !instance.isDisabled() }, questionId);
                    },
                };

                window.WEBSPELLCHECKER.init({
                    ...config,
                    ...getWProofReaderLanguage(),
                    ...getQuestionConfig(questionId),
                });
            } catch (e) {
                console.error('Unable to init WProofReader on CKEditor instance', e);
            }
        }
    },
};

export default spellcheckerConfig;
